import axios from 'axios';
import { AuthActions } from './auth.action';
import { getServerCore, defaultSnackbarTimeout, UploadFileApi } from '../../../../utils';
import { addUserDetails } from './auth.utils';
import { showSuccessSnackbar } from '../../Snackbar/snackbar.action';

const { serverUrls } = getServerCore();
const authUrl = serverUrls.getAuthUrl();
const defaultUrl = serverUrls.getDefaulUrl();

export const userRegistrationAsync = (user) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.userRegisterStart());
            const newUserDetails = await addUserDetails(user);
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/register`,
                data: newUserDetails,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (data.responseCode === 200) {
                dispatch(AuthActions.userRegisterSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(AuthActions.userRegisterError(data.responseMessage));
                // dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            console.log(error)
            dispatch(AuthActions.userRegisterError());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const userRegistrationVerificationAsync = (details, id) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.userRegisterVerificationStart());
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/registerVerification/${id}`,
                data: details,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            
            if (data.responseCode === 200) {
                dispatch(AuthActions.userRegisterVerificationSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(AuthActions.userRegisterVerificationError(data.responseMessage));
                // dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            console.log(error)
            dispatch(AuthActions.userRegisterVerificationError());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

let updateProfileApi = async (userDetails, id) => {
    const { data } = await axios({
        method: "PUT",
        // url:`http://localhost:10001/RFID/v1/api/user/updateProfile/${id}`,
        url: `${authUrl}/updateProfile/${id}`,
        data: userDetails,
        headers: {
            'Content-Type': "application/json"
        }
    });
    return data;
}

export const CheckWalletAddress = (details) => {
    //let {id}=details
    return async (dispatch) => {
        try {
            dispatch(AuthActions.walletAddressStart());
            
            let { body } =  details;
            if(!details.walletAddress) {
                dispatch(AuthActions.walletAddressError());
                return dispatch(showSuccessSnackbar('error','Enter walletAddress', defaultSnackbarTimeout));
            }
            //    let newurl='http://localhost:10001/RFID/v1/api/user/checkwallet';
            const { data } = await axios({
                method: "PUT",
                url: `${authUrl}/checkwallet`, //newurl
                data: details,
                headers: {
                    'Content-Type': "application/json"
                }   
            });
            console.log(data)
            if (data.responseCode === 400) {
                dispatch(AuthActions.walletAddressSuccess(data.responseData));
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
               
            } else {
                
                dispatch(showSuccessSnackbar('success', 'Wallet Address Accepted ', defaultSnackbarTimeout));
               
            }
        } catch (error) {
            
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const userProfileInfoAsync = (id) => {
    return async (dispatch) => {
        try{
            dispatch(AuthActions.userBasicInformationStart());
            
            const {data} = await axios({
                method: "GET",
                url: `${authUrl}/getProfile/${id}`,
                headers: {
                    'Content-Type': "application/json"
                }
            })

            if (data.responseCode === 200) {
                dispatch(AuthActions.userBasicInformationSuccess(data.responseData));
            } else {
                dispatch(AuthActions.userBasicInformationError(data.responseMessage));
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
            
        } catch (err) {
            dispatch(AuthActions.userBasicInformationError());
            dispatch(showSuccessSnackbar('error', err.responseMessage, defaultSnackbarTimeout));
        } 
    }
}


export const userBasicInfoAsync = (userDetails, id) => {
    return async (dispatch) => {
        try {
           
            dispatch(AuthActions.userBasicInformationStart());
            const data = await updateProfileApi(userDetails, id)

            console.log(data)

            if (data.responseCode === 200) {
                dispatch(AuthActions.userBasicInformationSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(AuthActions.userBasicInformationError(data.responseMessage));
                 dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
            }
         catch (error) {
            dispatch(AuthActions.userBasicInformationError());
            dispatch(showSuccessSnackbar('error', error.responseMessage, defaultSnackbarTimeout));
        }
    
    }
}


export const phoneEmailOtp = (details) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.phoneEmailOtpStart());
            
            let { body } =  details;
            if(!body.contactNumber && !body.emailId) {
                dispatch(AuthActions.phoneEmailOtpError());
                return dispatch(showSuccessSnackbar('error','Enter contact number or email id', defaultSnackbarTimeout));
            }

            const { data } = await axios({
                method: "PUT",
                url: `${authUrl}/verifyEmailOrContactNumber/${details.id}`,
                data: body,
                headers: {
                    'Content-Type': "application/json"
                }   
            });
            if (data.responseCode === 200) {
                dispatch(AuthActions.phoneEmailOtpSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                //dispatch(AuthActions.phoneEmailOtpError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            //dispatch(AuthActions.phoneEmailOtpError());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const verifyPhoneEmailOtp = (details, id) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.userOtpVerificationStart());
            const { data } = await axios({
                method: "PUT",
                url: `${authUrl}/verifyOtp/${id}`,
                data: details,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            
            if (data.responseCode === 200) {
                dispatch(AuthActions.verifyOtpSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(AuthActions.verifyOtpError(data.responseMessage));
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            console.log(error)
            //dispatch(AuthActions.verifyOtpError());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}


// api call for User login
export const userLoginAsync = (reqData, showField) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.loginStart(showField))
            const newDetails = await addUserDetails(reqData);
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/login`,
                data: newDetails,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (data.responseCode === 200) {
                dispatch(AuthActions.loginSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', "Otp has been sent successfully", defaultSnackbarTimeout));
            } else {
                console.log('errorrr');
                dispatch(AuthActions.loginError(data.responseMessage));
            }
        } catch (error) {
            console.log(error)
            dispatch(AuthActions.loginError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

// User Login OTP Verification 
export const userLoginVerificationAsync = (details) => {
    return async (dispatch) => {
        const { body, id } = details
        try {
            dispatch(AuthActions.userLoginVerificationStart());
            const data = await axios({
                method: "POST",
                url: `${authUrl}/verifySecurityCode/${id}`,
                data: body,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (data.data.responseCode === 200) {
                dispatch(AuthActions.userLoginVerificationSuccess(data.data.responseData));
                dispatch(showSuccessSnackbar('success', "You have been logged in successfully", defaultSnackbarTimeout));
            } else {
                dispatch(AuthActions.userLoginVerificationError(data.data.responseMessage));
                dispatch(showSuccessSnackbar('error', data.data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(AuthActions.userLoginVerificationError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

//User logout 
export const userlogoutUserAsync = (id, activityId) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.userLogoutStart());
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/logout/${id}/${activityId}`,
            })
            if (data.responseCode === 200) {
                dispatch(AuthActions.userLogoutSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(AuthActions.userLogoutError(data.responseMessage));
                // dispatch(showSuccessSnackbar('error', "You have logged out successfully", defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(AuthActions.userLogoutError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

//User logout 
export const userProfileUpdateAsync = (userDetails, id, formData) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.uploadProfileImageStart());
            let profileResult;
            if (formData) {
                const data = await UploadFileApi(formData);
                profileResult = data;
            }
            /*if(userDetails.walletAddress){
                dispatch(AuthActions.walletAddressStart());

                   let newurl='http://localhost:10001/RFID/v1/api/user/checkwallet';
                const { data } = await axios({
                    method: "PUT",
                    url:   newurl,//`${authUrl}/checkwallet/`,
                    data: userDetails,
                    headers: {
                        'Content-Type': "application/json"
                    }   
                });
                console.log(data.responseCode)
                if (data.responseCode === 400) {
                    delete userDetails.walletAddress
                    console.log(userDetails.walletAddress)
                    dispatch(AuthActions.walletAddressSuccess(data.responseData));
                    dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        }*/
            let finalUserDetails = userDetails;
            if (formData && profileResult && profileResult.responseCode === 200) {
                finalUserDetails = {
                    ...finalUserDetails,
                    profilePicture: profileResult.responseData
                }
            }
            const result = await updateProfileApi(finalUserDetails, id)
            if (result.responseCode === 200) {
                dispatch(AuthActions.uploadProfileImageSuccess(result.responseData));
                return dispatch(showSuccessSnackbar('success', result.responseMessage, defaultSnackbarTimeout));
            }
            // }
            
            dispatch(AuthActions.uploadProfileImageError(result.responseMessage));
            dispatch(showSuccessSnackbar('error', result.responseMessage, defaultSnackbarTimeout));
        } catch (error) {
            dispatch(AuthActions.uploadProfileImageError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const forgotPasswordAsync = (values) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.forgotPasswordStart());
            const {emailId, contactNumber} = values
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/forgotPassword`,
                headers: {
                    'Content-Type': "application/json"
                },
                data: emailId ? { emailId } : { contactNumber },
            });
            if (data.responseCode === 200) {
                dispatch(AuthActions.forgotPasswordSuccess(data.responseData));
                return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            }
            dispatch(showSuccessSnackbar('error', data.responseMessage, 3000));
            return dispatch(AuthActions.forgotPasswordError(data.responseMessage));
        } catch (error) {
            dispatch(AuthActions.forgotPasswordError());
            return dispatch(showSuccessSnackbar('error', "Error while sending link to your e-mail id.", 3000));
        }
    }
}

export const setNewPasswordAsync = ({ resetToken, password }) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.setNewPasswordStart());
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/setNewPassword/${resetToken}`,
                headers: {
                    'Content-Type': "application/json"
                },
                data: { password },
            });
            console.log(data);
            if (data.responseCode === 200) {
                dispatch(AuthActions.setNewPasswordSuccess(data.responseData));
                return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            }
            return dispatch(AuthActions.setNewPasswordError(data.responseMessage));
        } catch (error) {
            dispatch(AuthActions.setNewPasswordError());
            return dispatch(showSuccessSnackbar('error', "Error while changing password. Please try again later", 3000));
        }
    }
}

export const contactUsAsync = (details) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.contactUsStart());
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/contactUs`,
                headers: {
                    'Content-Type': "application/json"
                },
                data: details,
            });
            console.log(data);
            if (data.responseCode === 200) {
                dispatch(AuthActions.contactUsSuccess(data.responseData));
            }
            return dispatch(AuthActions.contactUsError(data.responseMessage));
        } catch (error) {
            dispatch(AuthActions.contactUsError());
            return dispatch(showSuccessSnackbar('error', error.message, 3000));
        }
    }
}

export const getAllCMSPagesAsync = () => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.getAllCMSPagesStart());
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/getAllCMSPages`,
                headers: {
                    'Content-Type': "application/json"
                },
            });
            console.log(data);
            if (data.responseCode === 200) {
                let finalData = {};
                data.responseData.map(dt => {
                    finalData[dt.type] = dt;
                })
                return dispatch(AuthActions.getAllCMSPagesSuccess(finalData));
            }
            return dispatch(AuthActions.getAllCMSPagesError(data.responseMessage));
        } catch (error) {
            dispatch(AuthActions.getAllCMSPagesError());
            // return dispatch(showSuccessSnackbar('error', error.message, 3000));
        }
    }
}

export const getEmissionDetails = () => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.getEmissionDetailsStart());
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/getEmissionDetails`,
                headers: {
                    'Content-Type': "application/json"
                },
            });
            console.log(data);
            if (data.responseCode === 200) {
                return dispatch(AuthActions.getEmissionDetailsSuccess(data.responseData));
            }
            return dispatch(AuthActions.getEmissionDetailsError(data.responseMessage));
        } catch (error) {
            dispatch(AuthActions.getEmissionDetailsError());
            // return dispatch(showSuccessSnackbar('error', error.message, 3000));
        }
    }
}

export const getCMSDetailsAsync = (id) => {
    return async (dispatch) => {
        try {
            dispatch(AuthActions.getCMSDetailsStart());
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/getCMSDetails/${id}`,
                headers: {
                    'Content-Type': "application/json"
                },
            });
            console.log(data);
            if (data.responseCode === 200) {
                dispatch(AuthActions.getCMSDetailsSuccess(data.responseData));
            }
            return dispatch(AuthActions.getCMSDetailsError(data.responseMessage));
        } catch (error) {
            dispatch(AuthActions.getCMSDetailsError());
            return dispatch(showSuccessSnackbar('error', error.message, 3000));
        }
    }
}

export const verifyAuthTokenAsync = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(AuthActions.verifyAuthTokenStart());
            let { _id } = getState().auth.user;
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/verify/${_id}`,
            });
            console.log(data);
            if (data.responseCode === 200) {
                return dispatch(AuthActions.verifyAuthTokenSuccess(data.responseData));
                // return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            }
            dispatch(AuthActions.verifyAuthTokenError());
            // return dispatch(showSuccessSnackbar('error', 'Please login again.', 3000));
        } catch (error) {
            dispatch(AuthActions.verifyAuthTokenError());
            // return dispatch(showSuccessSnackbar('error', "Error while sending otp. Please try again later", 3000));
        }
    }
}

//user resend code
export const resendVerificationCodeAsync = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(AuthActions.resendCodeStart());
            let { emailId, _id, contactNumber } = getState().auth.user;
            const resBody = {
                emailId: emailId,
                contactNumber: contactNumber
            }
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/resendCode/${_id}`,
                headers: {
                    'Content-Type': "application/json"
                },
                data: resBody,
            });
            console.log(data);
            if (data.responseCode === 200) {
                dispatch(AuthActions.resendCodeSuccess(data.responseData));
                return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            }
            dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            return dispatch(AuthActions.resendCodeError(data.responseMessage));
        } catch (error) {
            return dispatch(showSuccessSnackbar('error', error.message, 3000));
        }
    }
}

export const UploadDocumentAsync = (id, docDetails, formData, oldDocuments) => async (dispatch) => {
    try {
        dispatch(AuthActions.uploadDocumentStart());
        let fileResp, finalData, finalResult;
        finalData = docDetails;
        if (formData) {
            fileResp = await UploadFileApi(formData);
            finalResult = fileResp
        }
        if (fileResp && fileResp.responseCode === 200) {
            finalData = {
                ...docDetails,
                URL: fileResp.responseData
            }
        }
        if (fileResp && fileResp.responseCode !== 200) {
            dispatch(AuthActions.uploadProfileImageError(finalResult.responseMessage));
            return dispatch(showSuccessSnackbar('error', finalResult.responseMessage, defaultSnackbarTimeout));
        }
        console.log(finalData)
        let document = [];
        if (finalData) {
            document = [finalData];
        }
        if (oldDocuments) {
            document = [
                ...document,
                ...oldDocuments
            ]
        }
        console.log(document)
        finalResult = await updateProfileApi({ document }, id)
        if (finalResult.responseCode === 200) {
            dispatch(AuthActions.uploadDocumentSuccess(finalResult.responseData));
            return dispatch(showSuccessSnackbar('success', finalResult.responseMessage, defaultSnackbarTimeout));
        }
        dispatch(AuthActions.uploadProfileImageError(finalResult.responseMessage));
        dispatch(showSuccessSnackbar('error', finalResult.responseMessage, defaultSnackbarTimeout));
    } catch (error) {
        console.log(error)
        dispatch(AuthActions.uploadDocumentError());
        return dispatch(showSuccessSnackbar('error', "Error while uploading document. Please try again later", 3000));
    }
}

export const getProfileDashboardAsync = () => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(AuthActions.getProfileDashboardStart());
            let withdrawalResult = await axios({
                method: 'POST',
                url: `${authUrl}/getAllWithdraw/${_id}/0/0/all`,
            })
            let purchaseResult = await axios({
                method: 'POST',
                data: {status: 'CONFIRMED'},
                url: `${authUrl}/getAllPurchaseGoldOrderById/${_id}/0/0/all`,
            })
            withdrawalResult = withdrawalResult.data;
            purchaseResult = purchaseResult.data;
            let finalData = {
                goldAcquired: 0,
                availableTokens: 0,
                withdarawTokens: 0,
                totalTokensAcquired: 0,
                list: [],
            }
            if (purchaseResult.responseCode === 200) {
                purchaseResult.responseData.list.forEach(dt => {
                    finalData.totalTokensAcquired += parseInt(dt.tokens)
                    finalData.goldAcquired += parseFloat(dt.units)

                })
                finalData.list = purchaseResult.responseData.list;
            }
            if (withdrawalResult.responseCode === 200) {
                withdrawalResult.responseData.forEach(dt => {
                    finalData.withdarawTokens += parseInt(dt.tokens)
                    finalData.goldAcquired -= parseFloat(dt.units)
                })
            }

            finalData.availableTokens = finalData.totalTokensAcquired - finalData.withdarawTokens;
            console.log(finalData)
            if (purchaseResult.responseCode === 200 && withdrawalResult.responseCode === 200) {
                return dispatch(AuthActions.getProfileDashboardSuccess(finalData));
                // return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            }
            dispatch(AuthActions.getProfileDashboardError());
            dispatch(showSuccessSnackbar('error', "Error fetching data.Please try again after sometime.", 3000));
        } catch (error) {
            dispatch(AuthActions.getProfileDashboardError());
            dispatch(showSuccessSnackbar('error', "Error fetching data.Please try again after sometime.", 3000));
        }
    }
}




